import React from "react";

const STYLES = {
  open: "bg-[#0D9488] text-white",
  pending: "bg-amber-100 text-amber-800",
  resolved: "bg-slate-100 text-slate-600",
};

export const TicketStatusBadge = ({ status, testId }) => (
  <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold capitalize ${STYLES[status] || STYLES.open}`} data-testid={testId || "ticket-status-badge"}>
    {status}
  </span>
);
